module.exports = __webpack_public_path__ + "img/gcash-how-it-works-1.afd4fbb6.png";